export default (dispatch) => ({
  onChange(e, overlay) {
    if (e) {
      dispatch({
        type: 'layers/enableOverlay',
        payload: overlay
      });
    } else {
      dispatch({
        type: 'layers/disableOverlay',
        payload: overlay
      });
    }
  }
});